import { Component, OnInit } from "@angular/core";
import { LoginService } from "../../services/login.service";
import { Router } from "@angular/router";
import {
    AbstractControl,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from "@angular/forms";
import { UserService } from "../../services/user.service";
import { ToastService } from "../../services/toast.service";

@Component({
    selector: "app-new-password",
    templateUrl: "./new-password.component.html",
    styleUrls: ["./new-password.component.scss"],
    standalone: false
})
export class NewPasswordComponent implements OnInit {
    public newPasswordForm: FormGroup = new FormGroup(
        {
            passwordTemporary: new FormControl("", [Validators.required]),
            passwordNew: new FormControl("", [
                Validators.required,
                Validators.minLength(8),
            ]),
            passwordConfirm: new FormControl("", [Validators.required]),
        },
        { validators: compareValidator }
    );

    constructor(
        private readonly userService: UserService,
        private readonly loginService: LoginService,
        private readonly toastService: ToastService,
        private readonly router: Router
    ) {}

    ngOnInit(): void {}

    onSubmit() {
        if (!this.newPasswordForm.valid) {
            this.passwordTemporary.markAsTouched();
            return;
        }

        this.userService
            .savePassword(this.passwordTemporary.value, this.passwordNew.value)
            .then((c) => {
                if (c && c.success) {
                    this.toastService.add(
                        "Password changed",
                        "Password has been changed. Please login again",
                        "success"
                    );

                    this.loginService.logout();
                    this.router.navigate(["/login"]);
                } else {
                    this.passwordTemporary.reset();
                    this.passwordTemporary.markAsTouched();
                    this.passwordTemporary.setErrors({ incorrect: true });
                }
            });
    }

    get passwordTemporary(): FormControl {
        return this.newPasswordForm.get("passwordTemporary") as FormControl;
    }

    get passwordNew(): FormControl {
        return this.newPasswordForm.get("passwordNew") as FormControl;
    }

    get passwordConfirm(): FormControl {
        return this.newPasswordForm.get("passwordConfirm") as FormControl;
    }
}

export const compareValidator: ValidatorFn = (
    control: AbstractControl
): ValidationErrors | null => {
    const passwordTemporary = control.get("passwordTemporary");
    const passwordNew = control.get("passwordNew");
    const passwordConfirm = control.get("passwordConfirm");

    if (
        passwordTemporary &&
        passwordNew &&
        passwordTemporary.value === passwordNew.value
    ) {
        return { passwordMatch: true };
    }

    return passwordNew &&
        passwordConfirm &&
        passwordNew.value !== passwordConfirm.value
        ? { passwordMismatch: true }
        : null;
};
